import { useAtom } from "jotai/index";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import MttAnalyticsModule from "@/module/service-configs-module/mtt-analytics-module/mtt-analytics-module";
import { headerTitle } from "@/store/store";

const MttAnalyticsPage = () => {
  const { t } = useTranslation();
  const [, setHeaderTitle] = useAtom(headerTitle);

  useEffect(() => {
    setHeaderTitle(t("mttAnalytics"));
  }, [setHeaderTitle, t]);

  return <MttAnalyticsModule />;
};

export default MttAnalyticsPage;
